import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { formatDate } from 'src/app/_helper/functions';
import { DadosColaborador, MembroContratado } from 'src/app/models';
import { Movimentacao, Projeto } from 'src/app/types';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ApiService {
    readonly url = environment.apiUrl;

    constructor(private http: HttpClient, public router: Router) {}
    public cache = {};

    requisicoesAux;
    getProjeto(id) {
        const v = `projetos/projetosdadosbasicos/${id}/`;

        return this.http.get<Projeto>(this.url + v);
    }
    exportData(id_projeto) {
        return this.http.get<Array<any>>(
            `${this.url}projetos/exportarequipe/${id_projeto}/?format=json`
        );
    }

    getProjetos() {
        const v = 'projetos/projetoslistaprojetos/';

        return this.http.get<Projeto[]>(this.url + v);
    }

    getEquipe({ id_projeto }) {
        return this.http
            .get<MembroContratado[]>(
                this.url + `projetos/equipeprojetolist/${id_projeto}/`
            )
            .pipe(
                map(element => {
                    return element.map(item => {
                        // convert django date to javascript date
                        if (!item.fim_vigencia) return item;
                        return {
                            ...item,
                            fim_vigencia: formatDate(item.fim_vigencia),
                        };
                    });
                })
            );
    }

    getColaborador(id) {
        return this.http.get<DadosColaborador>(
            this.url + `colaboradorcrud/${id}/`
        );
    }

    getDocumentos(id = null) {
        if (id) {
            return this.http.get(`${this.url}documentos/${id}/`);
        } else {
            if (this.cache['getDocumentosForm']) {
                return of(this.cache['getDocumentosForm']);
            }
            return this.http.get(this.url + 'documentos/').pipe(
                tap(res => {
                    this.cache['getDocumentosForm'] = res;
                })
            );
        }
    }

    getInteressados(id_documento) {
        return this.http.get<Array<any>>(
            `${this.url}documentos/interessados/${id_documento}/`
        );
    }

    postInteressados(id_documento, values) {
        const data = {
            ...values,
            id_documento: id_documento,
        };
        return this.http.post(`${this.url}documentos/interessados/`, data);
    }

    removeInteressado(id_documento_interessado) {
        return this.http.delete(
            `${this.url}documentos/interessados/${id_documento_interessado}/`
        );
    }

    postRecibo(data) {
        return this.http.post(this.url + 'reciboeletronico/', data);
    }

    colaboradorRequisicoes = {
        get: () => {
            if (this.requisicoesAux) return of(this.requisicoesAux);
            return this.http
                .get<any>(this.url + 'colaborador/requisicoes/')
                .pipe(tap(res => (this.requisicoesAux = res)));
        },
        post: data => {
            return this.http.post(this.url + 'colaborador/requisicoes/', data);
        },
        retornar: (data, id_documento) => {
            return this.http.post(
                `${this.url}colaborador/requisicoes/${id_documento}/retornar/`,
                data
            );
        },
        concluir: (data, id_documento) => {
            return this.http.post(
                `${this.url}colaborador/requisicoes/${id_documento}/concluir/`,
                {}
            );
        },
    };

    cancelaRecibo(data) {
        return this.http.put(
            `${this.url}reciboeletronico/${data['id']}/`,
            data
        );
    }
    cancelaRequisicao(data, id_documento) {
        return this.http.put(
            `${this.url}colaborador/requisicoes/${id_documento}/`,
            data
        );
    }

    atendeRequisicao(id_documento, data) {
        // printFormData(data)
        // return throwError(new Error("TESTE"));
        return this.http.post(
            `${this.url}colaborador/requisicoes/${id_documento}/responder/`,
            data
        );
    }

    getMovimentacoes(id) {
        return this.http.get<Movimentacao[]>(this.url + `movimentacoes/${id}/`);
    }

    public async downloadResource(url): Promise<Blob> {
        const file = await this.http
            .get<Blob>(url, { responseType: 'blob' as 'json' })
            .toPromise();
        return file;
    }
}
